import { render, staticRenderFns } from "./deductionInfo.vue?vue&type=template&id=951deebe&scoped=true&"
import script from "./deductionInfo.vue?vue&type=script&lang=js&"
export * from "./deductionInfo.vue?vue&type=script&lang=js&"
import style0 from "./deductionInfo.vue?vue&type=style&index=0&id=951deebe&prod&lang=scss&scoped=true&"
import style1 from "./deductionInfo.vue?vue&type=style&index=1&id=951deebe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951deebe",
  null
  
)

export default component.exports